<ion-header>
  <ion-toolbar color="primary">
    <ion-title>Réinitialisation</ion-title>
  </ion-toolbar>
</ion-header>

<div class="inner-content">
  <ion-grid class="white-bg">
    <ion-row class="ion-text-center">
      <ion-col size="2"></ion-col>
      <ion-col size="8">
        <ion-label>Attention, vous allez effacer la configuration du cylindre
          <strong>{{device.properties.name |titlecase}}</strong>, cette action est
          définitive.</ion-label>
        <br>
        <ion-label>Souhaitez vous continuer ?</ion-label>
      </ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
  </ion-grid>
</div>

<ion-footer>
  <ion-toolbar>
    <ion-row class="ion-text-center">
      <ion-col size="2"></ion-col>
      <ion-col size="8">
        <ion-button color="primary" (click)="dismissModal()">
          Annuler
        </ion-button>
        <ion-button [disabled]="hasResetAction" color="primary" (click)="reset()">
          <ion-label *ngIf="!hasResetAction">Continuer</ion-label>
          <ion-spinner *ngIf="hasResetAction"></ion-spinner>
        </ion-button>
      </ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>